export default function formHandler() {
  if(document.location.href.includes('donate-paypal')) {
    document.querySelector('#new_newsletter_form').addEventListener("submit", (event) => {
      document.querySelector('#newsletter-container').remove()
    });
  }
}